import type { ComponentTheme } from '../types/component-theme';

import { RowStates } from './constants/row-states';

const labelStyles = 'font-(family-name:--secondary-font) text-[0.8rem] leading-[1.3]';

export default {
    slots: {
        root:
            'flex items-center justify-between gap-4 px-2 py-[0.6rem] transition-[background] duration-200 ' +
            'ease-[ease]',
        label: 'min-w-0 flex-1'
    },
    variants: {
        variant: {
            [RowStates.Accent]: {},
            [RowStates.BorderVisible]: {},
            [RowStates.Regular]: {
                root:
                    'border-b-[0.063rem] border-b-[rgba(148,163,184,0.1)] last:border-b-0 hover:rounded-[0.5rem] ' +
                    'hover:bg-(--white-alpha-35)'
            },
            [RowStates.Total]: {
                root: 'mt-1 border-t-2 border-t-(--slate-alpha-18) pt-[0.65rem] pb-[0.6rem]',
                label: `${labelStyles} text-(--text-strong)`
            },
            [RowStates.Final]: {
                root:
                    'mt-1 rounded-[0.5rem] border-t-2 border-t-(--indigo-alpha-20) px-[0.65rem] pt-3 pb-3 ' +
                    'bg-[linear-gradient(90deg,var(--indigo-alpha-06),var(--indigo-alpha-03))]',
                label: 'font-(family-name:--secondary-font) text-[0.85rem] leading-[1.3] text-(--input-neumorphic-text)'
            },
            [RowStates.Secondary]: {},
            [RowStates.Subtotal]: {}
        },
        secondary: {
            true: {
                label: `${labelStyles} text-(--accent-solid)`
            },
            false: {
                label: 'font-medium text-[0.8rem] leading-[1.3] text-(--accent-solid)'
            }
        }
    }
} satisfies ComponentTheme;
